export default "__VITE_ASSET__1WHV7tS5__"